package models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * One goal's share of one transaction.
 *
 * A transaction may fund several goals at once — the assignments table is unique
 * on `(transaction_id, goal_id)`, not on `transaction_id` — but a transaction
 * payload can only carry one `assigned_goal_id`. The server therefore reports the
 * LARGEST goal alongside the TOTAL of every share, which is right for a month
 * total and wrong for any per-goal number: the whole amount lands on the biggest
 * goal and the others read as unfunded.
 *
 * `assigned_goals` carries the real split. Anything that attributes money to a
 * particular goal reads this list; the single fields stay for display and for the
 * totals that legitimately want the sum.
 */
@Serializable
data class AssignedGoalShare(
    @SerialName("goal_id") val goalId: String,
    @SerialName("goal_name") val goalName: String = "",
    @SerialName("goal_icon") val goalIcon: String = "💰",
    val amount: Double = 0.0,
)
